import React from 'react';
import CountryToggler from './CountryToggler';

const FlagOnlyDropdown = ({ currentMapType }) => (
  <CountryToggler currentMapType={currentMapType} variant="flag" />
);

export default FlagOnlyDropdown;
